const zhCN = { 
  tabVisitorDeviceSettings: '访客一体机设置',
  
  visitorDeviceSettingsTitle: '访客机设置',

  departureTimeRequiredTxt: '访客申请是否必填离开时间 :',
  departureTimeRequiredDesc: '如设置为非必填，则离开时间默认为次日零点。',

  maximumAuthorizedTimeTxt: '访客最长授权时间',
  maximumAuthorizedTimeBlank: '访客最长授权时间不能为空！',
  maximumAuthorizedTimeWarning: '请填写正整数！',
  maximumAuthorizedTimUnit: '小时',

  issueAccessPermissions: '预约来访人员下发门禁权限 :',

  submitVisitorDeviceSettingsBtn: '提交设置',

  getVisitorDeviceSettingsFail: '获取访客一体机设置失败！',
  setVisitorDeviceSettingsSuccess: '访客一体机设置成功！',
  setVisitorDeviceSettingsFail: '访客一体机设置失败！'
}
const enUS = {
  tabVisitorDeviceSettings: 'Visitor All-in-one Machine',

  visitorDeviceSettingsTitle: 'Visitor all-in-one Machine Settings',

  departureTimeRequiredTxt: 'Departure time of visitor\'s application is required:',
  departureTimeRequiredDesc: 'If it is not required, the departure time defaults to zero of next day.',

  maximumAuthorizedTimeTxt: 'Maximum Authorized Time of Visitor',
  maximumAuthorizedTimeBlank: 'Maximum authorized time can\'t be blank!',
  maximumAuthorizedTimeWarning: 'Please fill in positive integers!',
  maximumAuthorizedTimUnit: 'hours',

  issueAccessPermissions: 'Issue access permissions to reserved visitor :',

  submitVisitorDeviceSettingsBtn: 'Submit Settings',

  getVisitorDeviceSettingsFail: 'Get WeChat mini-prog settings failed!',
  setVisitorDeviceSettingsSuccess: 'Submit WeChat mini-prog settings successful!',
  setVisitorDeviceSettingsFail: 'Submit WeChat mini-prog settings failed!'
}

export default { zhCN, enUS }